import { createUseStyles } from 'react-jss';

type RuleNames = 'container';

const styles = createUseStyles<RuleNames, unknown>({
    container: {},
});

export default styles;
